import React from 'react';
import type { HistoryPoint } from '../intelligence';
import { chrome } from '../reportTheme';

interface SparklineProps {
  points: HistoryPoint[];
  color: string;
  width?: number;
  height?: number;
}

/**
 * A trend's direction at a glance, beside a number that already says the
 * value - so no axis, no tooltip. Plain SVG: a charting library per table cell
 * would be most of the page's render time.
 */
const Sparkline: React.FC<SparklineProps> = ({ points, color, width = 96, height = 24 }) => {
  if (points.length < 2) {
    return (
      <svg width={width} height={height} aria-hidden>
        <line x1={0} x2={width} y1={height / 2} y2={height / 2} stroke={chrome.grid} strokeDasharray="3 3" />
      </svg>
    );
  }
  const values = points.map((p) => p.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const step = width / (points.length - 1);
  const path = points
    .map((p, i) => `${i === 0 ? 'M' : 'L'}${(i * step).toFixed(1)},${(height - 2 - ((p.value - min) / span) * (height - 4)).toFixed(1)}`)
    .join(' ');
  return (
    <svg width={width} height={height} aria-hidden>
      <path d={path} fill="none" stroke={color} strokeWidth={1.6} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
};

export default Sparkline;
